import React from 'react';
import { string } from 'prop-types';
import { Col, Row, Button } from '@thd-olt-component-react/core-ui';
import { stores } from './stores.json';

export const StoreInfo = ({ channel }) => {

  const onClick = (() => {
    window.open('https://hddc-appointment.extapps.homedepot.com/storeSelection', '_blank');
  });

  const viewAllItems = (() => {
    window.open(
      'https://www.homedepot.com/s/BuildLinkToHomeDepot?linktype=navigation&id=60c3bf9c-ac3c-492b-9a75-84d5bc0f5d5f',
      '_blank'
    );
  });

  return (
    <>
      <h4 className="store-header">Experience The Home Depot Design Center</h4>
      <p className="store-info">
        The Home Depot Design Center is your renovation destination
      </p>
      <ul className="store-info list list--type-square">
        <li className="list__item">A unique kitchen and bath showroom featuring 30+ full-sized kitchens & baths</li>
        <li className="list__item">Whether you are upgrading appliances or embarking on a full remodel,
          our skilled team of designers is ready to help you create and execute your ideal space
        </li>
        <li className="list__item">
          <a href="https://www.homedepot.com/c/designcenter" target="_blank" rel="noreferrer">
            Learn more about The Home Depot Design Center
          </a>
        </li>
      </ul>
      <Row className="store-details">
        {stores.map(({
          address,
          phone,
          hours
        }, index) => {
          const colClassNames = channel !== 'mobile'
            ? `store-details_${(index % 2 === 0 ? 'left' : 'right')}` : '';
          return (
            <Col sm="6" key={address.city} className={colClassNames}>
              <div className="store-details_card">
                <h4 className="store-details-header ">{address.city}, {address.state}</h4>
                <div className="store-details-address">
                  <div>{address.addressLine1}</div>
                  <div>{address.addressLine2}</div>
                  <div>{address.city}, {address.state} {address.zipCode}</div>
                </div>
                <div className="store-details-phone">
                  <a href={`tel:${phone}`} title={phone}>{phone}</a>
                </div>
                <div className="store-details-hours">
                  {hours.map((hour, hourIndex) => <div key={hourIndex}>{hour}</div>)}
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
      <Button onClick={onClick}>Schedule an Appointment</Button>
      <Button tag="a" onClick={viewAllItems} link transparent>View All Thermador Luxury Appliances</Button>
    </>
  );
};

StoreInfo.propTypes = {
  channel: string.isRequired
};
